import { SectionShell, Panel, Note } from "@/components/dash/primitives";
import { ChartTip, CHART, CHART_SEQ } from "@/components/dash/chartkit";
import {
  ResponsiveContainer, PieChart, Pie, Cell, BarChart, Bar, XAxis, YAxis,
  CartesianGrid, Tooltip, Legend, LabelList,
} from "recharts";

const PIE_COLORS = [
  CHART.blue, CHART.orange, CHART.green, CHART.violet, CHART.sky,
  CHART.amber, "#64748b", "#0f766e", "#be185d", "#cbd5e1",
];

export default function Carriers({ data, num, title }) {
  return (
    <SectionShell id="carriers" num={num} title={title}>
      <p className="text-slate-700 leading-relaxed max-w-4xl mb-8">{data.intro}</p>

      <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
        <Panel
          title="Global carrier market share"
          subtitle="By operated capacity — Top 30 carriers"
          source="Source: Alphaliner Monthly Monitor, Jun 2026 — Top 30 Carriers"
          testid="chart-market-share"
          csv={{ name: "Carrier market share", columns: ["Carrier", "Share %"], rows: data.market_share.map((d) => [d.name, d.value]) }}
        >
          <ResponsiveContainer width="100%" height={320}>
            <PieChart>
              <Pie
                data={data.market_share}
                dataKey="value"
                nameKey="name"
                cx="50%"
                cy="50%"
                innerRadius={62}
                outerRadius={110}
                paddingAngle={1.5}
              >
                {data.market_share.map((d, i) => (
                  <Cell key={i} fill={PIE_COLORS[i % PIE_COLORS.length]} stroke="#fff" strokeWidth={2} />
                ))}
              </Pie>
              <Tooltip content={<ChartTip formatter={(v) => `${v}%`} />} />
              <Legend wrapperStyle={{ fontSize: 11 }} />
            </PieChart>
          </ResponsiveContainer>
        </Panel>

        <Panel
          title="Key Southeast Asian transshipment hubs"
          subtitle="1Q 2026 volume (million TEU)"
          source="Source: Alphaliner Monthly Monitor, Jun 2026 — Top 30 Ports"
          testid="chart-hub-ports"
          csv={{ name: "Hub port volumes", columns: ["Port", "1Q26 volume (M TEU)", "YoY %"], rows: data.hubs.map((d) => [d.port, d.volume, d.yoy]) }}
        >
          <ResponsiveContainer width="100%" height={320}>
            <BarChart data={data.hubs} margin={{ top: 16, right: 8, left: 8, bottom: 0 }}>
              <CartesianGrid vertical={false} stroke="#f1f5f9" />
              <XAxis dataKey="port" tickLine={false} axisLine={false} tick={{ fill: "#64748b", fontSize: 12 }} />
              <YAxis tickFormatter={(v) => `${v}M`} tickLine={false} axisLine={false} tick={{ fill: "#64748b" }} width={40} />
              <Tooltip cursor={{ fill: "#f8fafc" }} content={<ChartTip formatter={(v, p) => `${v}M TEU  ·  +${p?.yoy}% YoY`} />} />
              <Bar dataKey="volume" name="1Q 2026 volume" fill={CHART.blue} radius={[4, 4, 0, 0]} maxBarSize={72}>
                <LabelList dataKey="volume" position="top" formatter={(v) => `${v}M`} className="font-num" fill="#334155" fontSize={12} />
              </Bar>
            </BarChart>
          </ResponsiveContainer>
        </Panel>
      </div>

      <Note>{data.share_note}</Note>
      <Note>{data.hub_note}</Note>
      <Note accent>{data.hub_why}</Note>
    </SectionShell>
  );
}
